"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Bind `target` event `eventName`'s callback `listener`.
 * @param  {Element} target
 * @param  {String} eventName
 * @param  {Function} listener
 * @param  {Boolean} capture
 * @return {Object}
 */
var _default = function _default(target, eventName, listener) {
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  target.addEventListener(eventName, listener, capture);
  return {
    off: function off() {
      target.removeEventListener(eventName, listener, capture);
    }
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/lib/events/on.js
// module id = 522
// module chunks = 0